var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSrc),expression:"currentSrc"}],ref:"imgField",staticClass:"auth-img",attrs:{"src":_vm.currentSrc},on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }